import { render } from "./vmemberdvcbuy.vue?vue&type=template&id=3201684c&scoped=true"
import script from "./vmemberdvcbuy.vue?vue&type=script&lang=js"
export * from "./vmemberdvcbuy.vue?vue&type=script&lang=js"

import "./vmemberdvcbuy.vue?vue&type=style&index=0&id=3201684c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3201684c"]])

export default __exports__